import { initOfficeHoverReveal } from "../component/office-hover-reveal.js";
import initMobileMenu from "../component/mobile-menu.js";
import { initContextMenu } from "../component/disable-rightclick.js";
import { initCookieBar,initDmcabadge,initGooglePreferredSource } from "../component/bottom-cookie-bar.js";
import { initGlowWrapper } from "../component/glow.js";

initContextMenu();
initOfficeHoverReveal();
initMobileMenu();
initDmcabadge();
initCookieBar();
initGooglePreferredSource();
document.addEventListener("DOMContentLoaded", () => {
    initGlowWrapper();
});